module.exports = __webpack_public_path__ + "static/media/pic41.46c33938.jpg";